module.exports = __webpack_public_path__ + "static/media/day_nine.ad1e50ac.jpg";